module.exports = __webpack_public_path__ + "2bc610498e174229970a36e16ef4a243.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/school-s.png
// module id = 1675
// module chunks = 0